"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const WishList_module_1 = tslib_1.__importDefault(require("./modules/WishList.module"));
const loadWishlistMenuItemModule = () => ({
    hasRouter: false,
    modules: [(0, WishList_module_1.default)()],
});
exports.default = loadWishlistMenuItemModule;
